import workerService from '@/modules/worker/services/workerService';

const DUPLICATE_EMAIL_CODE = 'WORKER.DUPLICATE_EMAIL';

interface ConflictError {
	response?: {
		status?: number;
		data?: { code?: string };
	};
}

/**
 * When a worker creation fails because the email already exists, the blocking worker
 * is not always surfaced by the duplicate search (it may be archived or excluded from
 * the read projection). Resolve its id directly so the caller can open the existing file.
 * Returns null when the conflict is not a duplicate email or the worker cannot be resolved.
 */
export const resolveDuplicateEmailWorkerId = async (
	error: unknown,
	email: string
): Promise<string | null> => {
	const response = (error as ConflictError).response;
	if (
		response?.status !== 409 ||
		response?.data?.code !== DUPLICATE_EMAIL_CODE
	) {
		return null;
	}

	try {
		const { workerId } = await workerService.getWorkerIdByEmail({ email });
		return workerId || null;
	} catch {
		return null;
	}
};
